import ServiceDetailPage from "./utilities/servicedetailpage";
import { servicePageContent } from "./utilities/servicepagecontent";

export default function APIGateways() {
  return <ServiceDetailPage service={servicePageContent.apiGateways} />;
}
